//
//
//
//
//

export default {
  name: 'app',
  created(){
    window.onbeforeunload = function(){
      console.log('刷新')
    }
  }
}
